export default __webpack_public_path__ + "static/media/agama.a7e32983.png";